import { type CSSProperties } from 'react'
import { styled, css } from 'next-yak'

import * as colors from '../constants/colors'
import * as zindex from '../constants/zindex'
import * as breakpoints from '../constants/breakpoints'
import { Overlay as ModalOverlay } from './modal'
import { fromLeftFadeIn } from '../behaviours/transition/transitions'
import { UnstyledButton } from './button'
import { Step } from '../behaviours/transition/useTransition'

type PanelProps = {
  width?: CSSProperties['width']
  padding?: CSSProperties['padding']
  $lockedScroll?: boolean
}

export const Overlay = styled(ModalOverlay)<{ open: boolean; step: Step }>`
  transition: opacity 300ms cubic-bezier(0.83, 0, 0.17, 1);

  ${({ open }) => {
    if (open) {
      return css`
        opacity: 1;
        pointer-events: auto;
      `
    } else {
      return css`
        opacity: 0;
        pointer-events: none;
      `
    }
  }}
`

const BasicPanel = styled.div<PanelProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  background: ${colors.PRIMARY_GREY_000};
  z-index: ${zindex.DRAWER};
  padding: ${({ padding }) => padding ?? '32px'};
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  ${({ $lockedScroll }) => {
    if ($lockedScroll) {
      return css`
        overflow-y: hidden;
      `
    }
  }}

  @media screen and (${breakpoints.TABLET}) {
    width: 75vw;
  }

  @media screen and (${breakpoints.LAPTOP}) {
    width: ${({ width }) => width};
  }
`
export const Panel = fromLeftFadeIn(BasicPanel)

export const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`
export const CloseButton = styled(UnstyledButton)`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  color: ${colors.PRIMARY_SAND_500};
`
